// extracted by mini-css-extract-plugin
export var column = "IconList-module--column--4a449";
export var container = "IconList-module--container--37a0f";
export var gridFix = "IconList-module--grid-fix--37110";
export var half = "IconList-module--half--bf83a";
export var imageContainer = "IconList-module--image-container--2ef7e";
export var ul = "IconList-module--ul--d4459";